import { faker } from '@faker-js/faker/locale/ru'
import { CitizenDocument, DocumentType } from './citizenDocuments'
import { UuidIdGenerator } from '../../../common'

export function mockCitizenDocument(citizenId: string, birthdate: Date): CitizenDocument {
  const idGenerator = new UuidIdGenerator()

  const doc: CitizenDocument = {
    createdAt: new Date(),
    type: [DocumentType.PASSPORT, DocumentType.OTHER][Math.floor(Math.random() * 2)],
    citizenId: citizenId,
    id: idGenerator.generate(),
  }
  switch (doc.type) {
    case DocumentType.PASSPORT:
      doc.series = faker.string.numeric(4)
      doc.num = faker.string.numeric(6)
      doc.issue = 'МО г. Ростов-на-Дону'
      doc.date = new Date(new Date().setFullYear(birthdate.getFullYear() + 18))
      break
    default:
      doc.name = faker.lorem.words(3)
      doc.info = faker.lorem.lines(1)
  }
  return doc
}
